import { render, staticRenderFns } from "./AnnotationRecordGrid.vue.js?vue&type=template&id=1ba0ee30&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGrid.vue?vue&type=template&id=1ba0ee30&scoped=true"
import script from "./AnnotationRecordGrid.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGrid.vue?vue&type=script&lang=js"
export * from "./AnnotationRecordGrid.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGrid.vue?vue&type=script&lang=js"
import style0 from "./AnnotationRecordGrid.vue.scss?vue&type=style&index=0&id=1ba0ee30&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGrid.vue?vue&type=style&index=0&id=1ba0ee30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0ee30",
  null
  
)

export default component.exports